<ul class="navbar-nav me-auto">
  <li class="nav-item">
    <!-- <app-nav-search /> -->
  </li>
</ul>
